import clsx from 'clsx'

import './staticHeader.scss'

interface StaticHeaderProps {
    title: string
    alignment?: 'left' | 'center' | 'right'
    divClassName?: string
    spanClassName?: string
}

export const StaticHeader = ({
    title,
    alignment = 'left',
    divClassName,
    spanClassName,
}: StaticHeaderProps) => {
    return (
        <div
            className={clsx(
                'static-header',
                `static-header--${alignment}`,
                divClassName
            )}
        >
            <span className={clsx('static-header__title', spanClassName)}>
                {title}
            </span>
        </div>
    )
}
